import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { auth, db } from "../App";
import { doc, getDoc } from "firebase/firestore";

const navLinkClass = ({ isActive }) =>
  [
    "relative inline-block pb-1 text-sm font-medium transition-colors",
    isActive
      ? "text-white after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-white/70"
      : "text-white/80 hover:text-white",
  ].join(" ");

function Navbar() {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (currentUser) => {
      setLoading(true);

      if (!currentUser) {
        setUser(null);
        setRole(null);
        setLoading(false);
        return;
      }

      setUser(currentUser);

      try {
        const snap = await getDoc(doc(db, "users", currentUser.uid));
        if (snap.exists()) {
          setRole(snap.data().role || "client");
        } else {
          setRole("client");
        }
      } catch (err) {
        console.error("Navbar role load error:", err);
        setRole("client");
      }

      setLoading(false);
    });

    return () => unsub();
  }, []);

  return (
    <nav className="bg-primary p-4 text-white">
      <div className="container mx-auto grid grid-cols-1 items-center gap-4 md:grid-cols-[auto_minmax(0,1fr)_auto] md:gap-x-6">
        <div className="flex shrink-0 items-center">
          <Link to="/" className="text-2xl font-bold">
            Mark Beattie
          </Link>
        </div>

        <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 md:min-w-0">
          <li>
            <NavLink to="/about" end className={navLinkClass}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/services" end className={navLinkClass}>
              Services
            </NavLink>
          </li>
          <li>
            <NavLink to="/portfolio" className={navLinkClass}>
              Portfolio
            </NavLink>
          </li>
          <li>
            <NavLink to="/blog" className={navLinkClass}>
              Blog
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" end className={navLinkClass}>
              Contact
            </NavLink>
          </li>
        </ul>

        <div className="flex flex-wrap items-center justify-center gap-3 md:shrink-0 md:justify-end">
          {!loading && (
            <>
              {user && role === "admin" && (
                <Link
                  to="/admin"
                  className="rounded-md border border-slate-500/40 bg-slate-700/50 px-3 py-1.5 text-sm font-medium text-white/80 transition-colors hover:bg-slate-600/60"
                >
                  Admin Dashboard
                </Link>
              )}

              {user && role !== "admin" && (
                <Link
                  to="/client-portal"
                  className="rounded-md border border-white/25 bg-white/10 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/20"
                >
                  Client Portal
                </Link>
              )}

              {!user && (
                <Link
                  to="/client-portal"
                  className="rounded-md border border-white/25 bg-white/10 px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-white/20"
                >
                  Client Login
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
